/**
 * Published sites API slice (<name>.sites.gabusercontent.com).
 * Leaf module: pulls only the shared chokepoint from ./client.
 */
import { fetchWithAuth } from './client';

const encodeName = (name) => encodeURIComponent(String(name || '').trim().toLowerCase());

export const SITE_REPORT_REASONS = [
  { value: 'phishing', label: 'Phishing or scam' },
  { value: 'malware', label: 'Malware or harmful downloads' },
  { value: 'sexual', label: 'Sexual content' },
  { value: 'child_safety', label: 'Child safety' },
  { value: 'violence', label: 'Violence or threats' },
  { value: 'hate', label: 'Hate speech' },
  { value: 'harassment', label: 'Harassment' },
  { value: 'illegal', label: 'Illegal content' },
  { value: 'copyright', label: 'Copyright infringement' },
  { value: 'spam', label: 'Spam' },
  { value: 'other', label: 'Something else' },
];

export const sitesApi = {
  list: () => fetchWithAuth('/json/sites'),
  names: (name) => fetchWithAuth('/json/sites/names', { method: 'POST', body: { candidates: [name] } }),
  publish: (body) => fetchWithAuth('/json/sites/publish', { method: 'POST', body, timeoutMs: 180000 }),
  get: (name) => fetchWithAuth(`/json/sites/${encodeName(name)}`),
  unpublish: (name) => fetchWithAuth(`/json/sites/${encodeName(name)}`, { method: 'DELETE' }),
  report: ({ name, reason, details }) => fetchWithAuth('/json/sites/report', {
    method: 'POST',
    body: { name: String(name || '').trim().toLowerCase(), reason, details: details ? String(details).slice(0, 2000) : undefined },
  }),
};
